import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { encryptData } from "../../UI/crypto";
import config from "../../config";
import { decryptURL } from "../../UI/URLencryption";
function Sidebar10() {
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const contentRef1 = useRef(null);
  const contentRef2 = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleDropdown1 = () => {
    setIsOpen1(!isOpen1);
  };

  const toggleDropdown2 = () => {
    setIsOpen2(!isOpen2);
  };

  useEffect(() => {
    if (contentRef1.current) {
      contentRef1.current.style.maxHeight = isOpen1
        ? `${contentRef1.current.scrollHeight}px`
        : "0px";
    }
  }, [isOpen1]);

  useEffect(() => {
    if (contentRef2.current) {
      contentRef2.current.style.maxHeight = isOpen2
        ? `${contentRef2.current.scrollHeight}px`
        : "0px";
    }
  }, [isOpen2]);

  const isAddSchoolActive = [
    "/class-x-regular-student",
    "/class-x-ex-regular-student",
    "/class-x-improvement-student",
  ].includes(location.pathname);

  const isReportsActive = [
    "/class-x-total-registration",
    "/class-x-checklist-generated",
    "/class-x-generate-challan",
    "/class-x-challan-status",
    "/class-x-consolidated-checklist",
  ].includes(location.pathname);
  // const downloadadmit = () => {
  //   const domain = window.location.origin;
  //   const districtId = sessionStorage.getItem("district");
  //   const schoolId = sessionStorage.getItem("schoolCode");

  //   if (!schoolId) {
  //     alert("School ID is missing.");
  //     return;
  //   }
  //   if (!districtId) {
  //     alert("District ID is missing.");
  //     return;
  //   }
  //   const filePath = `${domain}/Admit_cards/${districtId}/${schoolId}.pdf`;
  //   const link = document.createElement("a");
  //   link.href = filePath;
  //   link.download = `Admit-cards-${schoolId}.pdf`;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const downloadadmit = async () => {
    const fileurl = sessionStorage.getItem("class10admitcardlink");
    const distcode = sessionStorage.getItem("district");

    if (!fileurl) {
      alert("No admit card found");
      return;
    }

    const finalurl = decryptURL(fileurl);

    try {
      setLoading(true);
      setDownloadProgress(10);

      const res = await fetch(finalurl);
      setDownloadProgress(60);

      const blob = await res.blob();
      setDownloadProgress(90);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Admit_card_10_${distcode}.pdf`;
      a.click();

      window.URL.revokeObjectURL(url);

      setDownloadProgress(100);

      setTimeout(() => {
        setLoading(false);
        setDownloadProgress(0);
      }, 300);
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download");
      setLoading(false);
      setDownloadProgress(0);
    }
  };

  const downloadtr = () => {
    const domain = window.location.origin;
    const classFolder = "class-x";
    const districtId = sessionStorage.getItem("district");
    const schoolId = sessionStorage.getItem("schoolCode");

    if (!schoolId) {
      alert("School ID is missing.");
      return;
    }
    if (!districtId) {
      alert("District ID is missing.");
      return;
    }
    const filePath = `${domain}/${classFolder}/${districtId}/${schoolId}.pdf`;
    const link = document.createElement("a");
    link.href = filePath;
    link.download = `Tabulation-Register-${schoolId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const movetonextd = (e) => {
    e.preventDefault();

    const params = {
      schooL_CODE: sessionStorage.getItem("schoolCode"),
      schooL_NAME: sessionStorage.getItem("schoolname"),
      heaD_MOBILE_NO: sessionStorage.getItem("headMobileNo"),
      emaiL_ADDRESS: sessionStorage.getItem("schoolEmailId"),
      district: sessionStorage.getItem("district"),
      district_name: sessionStorage.getItem("districtname"),
      assistant_master_no: sessionStorage.getItem("assistantteachercontact"),
    };

    // console.log("Before Encrypt:", params);

    const encryptedData = encryptData(params, config.SECRET_KEY);
    const encodedData = encodeURIComponent(encryptedData);
    window.open(`${config.IA_LINK}/class-x?data=${encodedData}`, "_blank");
  };
  const lateralstatus = sessionStorage.getItem("Class10LateralStatus");
  return (
    <>
      {loading && (
        <div className="download-modal-overlay">
          <div className="download-modal">
            <div className="spinner"></div>

            <h4>Downloading Admit Card</h4>

            <div className="progress-wrapper">
              <div
                className="progress-bar"
                style={{ width: `${downloadProgress}%` }}
              ></div>
            </div>

            <p>{downloadProgress}% completed</p>
          </div>
        </div>
      )}
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <ul className="nav">
          <li
            className={`nav-item ${
              location.pathname === "/class-x-dashboard" ? "active" : ""
            }`}
          >
            <a
              style={{ cursor: "pointer" }}
              className="nav-link"
              onClick={() => navigate("/class-x-dashboard")}
            >
              <i className="icon-grid menu-icon"></i>
              <span className="menu-title">Dashboard</span>
            </a>
          </li>

          <li
            className={`nav-item ${
              location.pathname === "/class-x-school-profile" ? "active" : ""
            }`}
          >
            <a
              style={{ cursor: "pointer" }}
              className="nav-link"
              onClick={() => navigate("/class-x-school-profile")}
            >
              <i className="fa fa-university menu-icon"></i>
              <span className="menu-title">School Profile</span>
            </a>
          </li>

          <li className={`nav-item ${isAddSchoolActive ? "active" : ""}`}>
            <a
              className="nav-link"
              onClick={toggleDropdown1}
              style={{ cursor: "pointer" }}
              aria-expanded={isOpen1}
              aria-controls="auth1"
            >
              <i className="icon-head menu-icon"></i>
              <span className="menu-title">Add Student</span>
              <i className="menu-arrow"></i>
            </a>
            <div id="auth1" ref={contentRef1} className="custom-collapse">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-x-regular-student");
                    }}
                  >
                    Class X Regular
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-x-ex-regular-student");
                    }}
                    rel="noopener noreferrer"
                  >
                    Ex-Regular
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-x-improvement-student");
                    }}
                    rel="noopener noreferrer"
                  >
                    Improvement
                  </a>
                </li>
              </ul>
            </div>
          </li>

          <li className={`nav-item ${isReportsActive ? "active" : ""}`}>
            <a
              className="nav-link"
              onClick={toggleDropdown2}
              style={{ cursor: "pointer" }}
              aria-expanded={isOpen2}
              aria-controls="auth2"
            >
              <i className="icon-head menu-icon"></i>
              <span className="menu-title">Reports</span>
              <i className="menu-arrow"></i>
            </a>
            <div id="auth2" ref={contentRef2} className="custom-collapse">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-x-total-registration");
                    }}
                    rel="noopener noreferrer"
                  >
                    Total Registration
                  </a>
                </li>{" "}
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-x-checklist-generated");
                    }}
                    rel="noopener noreferrer"
                  >
                    Checklist Generated
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-x-generate-challan");
                    }}
                    rel="noopener noreferrer"
                  >
                    Generate Challan
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-x-challan-status");
                    }}
                    rel="noopener noreferrer"
                  >
                    Challan Status
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-x-consolidated-checklist");
                    }}
                    rel="noopener noreferrer"
                  >
                    List of Registered <br></br>Students
                  </a>
                </li>
              </ul>
            </div>
          </li>
          {sessionStorage.getItem("correctionstatus") === "ON" && (
            <li className="nav-item">
              <a
                className="nav-link"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/class-x-correct-student");
                }}
              >
                <i class="fa fa-check menu-icon"></i>
                <span className="menu-title ">Correct Student Data</span>
              </a>
            </li>
          )}

          <li
            className={`nav-item ${
              location.pathname === "/class-x-data-not-found" ? "active" : ""
            }`}
          >
            <a
              className="nav-link text-danger"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate("/class-x-data-not-found");
              }}
            >
              <i class="fa fa-times menu-icon text-danger"></i>
              <span className="menu-title ">Data Not Found</span>
            </a>
          </li>

          <li
            className={`nav-item ${
              location.pathname === "/class-x-data-not-found-list"
                ? "active"
                : ""
            }`}
          >
            <a
              className="nav-link text-danger"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate("/class-x-data-not-found-list");
              }}
            >
              <i class="fa fa-list menu-icon text-danger"></i>
              <span className="menu-title " style={{ fontSize: "13px" }}>
                Status of Data Not Found
              </span>
            </a>
          </li>

          {sessionStorage.getItem("class10admitcardbutton") === "ON" &&
            sessionStorage.getItem("class10admitcardlink") && (
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    downloadadmit();
                  }}
                >
                  <i className="fa fa-download menu-icon"></i>
                  <span className="menu-title">Download Admit Card</span>
                </a>
              </li>
            )}
          {sessionStorage.getItem("tabulationReg") === "ON" && (
            <li className="nav-item blink-text" style={{ padding: "1px 6px" }}>
              <a
                className="nav-link color btn btn-danger text-white"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  downloadtr();
                }}
                style={{
                  backgroundColor: "#dc3545",
                  padding: "8px 12px",
                  borderRadius: "3px",
                }}
              >
                <i className="fa fa-download menu-icon text-white"></i>
                <span className="menu-title" style={{ fontSize: "12px" }}>
                  TABULATION REGISTER
                </span>
              </a>
            </li>
          )}
          {sessionStorage.getItem("class10IAportal") === "ON" && (
            <li className="nav-item">
              <a
                className="nav-link nav-link-ia text-white"
                href="#"
                onClick={movetonextd}
              >
                <i className="fa fa-arrow-right menu-icon text-primary"></i>
                <span
                  className="menu-title text-primary"
                  style={{ fontSize: "13px", fontWeight: "600" }}
                >
                  IA/Practical Marks Portal
                </span>
              </a>
            </li>
          )}
          {lateralstatus && lateralstatus === "ON" && (
            <li
              className={`nav-item ${
                location.pathname === "/class-x-backdoor-generate-challan"
                  ? "active"
                  : ""
              }`}
            >
              <a
                style={{ cursor: "pointer" }}
                className="nav-link"
                onClick={() => navigate("/class-x-backdoor-generate-challan")}
              >
                <i class="fa fa-list menu-icon"></i>
                <span className="menu-title">Lateral Generate Challan</span>
              </a>
            </li>
          )}
          {/* )} */}
        </ul>
      </nav>
    </>
  );
}

export default Sidebar10;
